import { ArrowRight2, Chart, Flashy } from 'iconsax-react';
import UsageTab from '@features/settings/pages/billing/components/usage';
import { createColumnHelper } from '@tanstack/react-table';
import { Badge } from '@design-system/badge';
import { Dialog, DialogContent, DialogTrigger } from '@design-system/dialog';
import InvoiceDialog from './dialogs/invoice-dialog';
import UpgradeTab from '@features/settings/pages/billing/components/upgrade';

export const billingTabs = [
  {
    label: 'Usage',
    value: 'usage',
    default: true,
    icon: <Chart />,
    content: <UsageTab />,
  },
  {
    label: 'Upgrade',
    value: 'upgrade',
    icon: <Flashy />,
    content: <UpgradeTab />,
  },
];

const columnHelper = createColumnHelper<{
  plan: string;
  type: string;
  date: string;
  amount: number;
  status: 'UPCOMING' | 'PAID' | 'CANCELED' | 'FAILED';
}>();

export const billingTabColumn = [
  columnHelper.accessor('plan', {
    id: 'plan',
    header: 'Plan',
    cell: ({ row }) => row.original.plan,
  }),
  columnHelper.accessor('type', {
    id: 'status',
    cell: ({ row }) => row.original.type,
    header: 'Type',
  }),
  columnHelper.accessor('date', {
    id: 'date',
    cell: ({ row }) => row.original.date,
    header: 'Date',
  }),
  columnHelper.accessor('amount', {
    id: 'amount',
    cell: ({ row }) => row.original.amount,
    header: 'Amount',
  }),
  columnHelper.accessor('status', {
    id: 'status',
    cell: ({ row }) => (
      <div className='flex items-center justify-between'>
        <Badge
          variant={
            row.original.status === 'PAID'
              ? 'success'
              : row.original.status === 'UPCOMING'
                ? 'warning'
                : 'danger'
          }
          className='w-fit capitalize font-normal py-1'
        >
          {row.original.status.toLocaleLowerCase()}
        </Badge>
        <Dialog>
          <DialogTrigger>
            <ArrowRight2
              size='11'
              color='#584777'
              cursor='pointer'
            />
          </DialogTrigger>
          <DialogContent>
            <InvoiceDialog status={row.original.status} />
          </DialogContent>
        </Dialog>
      </div>
    ),
    header: 'Status',
  }),
];
